import { Grid, Typography } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";

const PDFHeader = ({ logoURL }) => {
  const {
    keycloak: { tokenParsed },
  } = useKeycloak();

  return (
    <Grid container alignItems="center" sx={{ p: 3 }}>
      <Grid item>
        <img width={120} height={100} alt="bank-logo" src={logoURL} />
      </Grid>
      <Grid item>
        <Typography fontSize="1.5rem" marginX="20px">
          {tokenParsed.BIC}
        </Typography>
      </Grid>
      <Grid item>
        <Typography fontSize="1.5rem">{tokenParsed.bankName}</Typography>
      </Grid>
    </Grid>
  );
};

export default PDFHeader;
